/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PersonIdSchoolEducations202,
  PostApiV1PersonIdSchoolEducations400,
  PostApiV1PersonIdSchoolEducations401,
  PostApiV1PersonIdSchoolEducations404,
  PostApiV1PersonIdSchoolEducations500,
  PostApiV1PersonIdSchoolEducationsMutationRequest,
  PostApiV1PersonIdSchoolEducationsMutationResponse,
  PostApiV1PersonIdSchoolEducationsPathParams,
} from "../../types/personStudentController/PostApiV1PersonIdSchoolEducations.ts";
import { createSchoolEducationViewModelSchema } from "../createSchoolEducationViewModelSchema.ts";
import { schoolEducationDetailViewModelSchema } from "../schoolEducationDetailViewModelSchema.ts";

export const postApiV1PersonIdSchoolEducationsPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1PersonIdSchoolEducationsPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1PersonIdSchoolEducations202Schema = z.lazy(
  () => schoolEducationDetailViewModelSchema,
) as unknown as ToZod<PostApiV1PersonIdSchoolEducations202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1PersonIdSchoolEducations400Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdSchoolEducations400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PersonIdSchoolEducations401Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdSchoolEducations401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1PersonIdSchoolEducations404Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdSchoolEducations404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PersonIdSchoolEducations500Schema =
  z.any() as unknown as ToZod<PostApiV1PersonIdSchoolEducations500>;

export const postApiV1PersonIdSchoolEducationsMutationRequestSchema = z.lazy(
  () => createSchoolEducationViewModelSchema,
) as unknown as ToZod<PostApiV1PersonIdSchoolEducationsMutationRequest>;

export const postApiV1PersonIdSchoolEducationsMutationResponseSchema = z.lazy(
  () => postApiV1PersonIdSchoolEducations202Schema,
) as unknown as ToZod<PostApiV1PersonIdSchoolEducationsMutationResponse>;
